import { createTheme } from "@mui/material/styles";
const theme = createTheme({
    palette: {
      secondary: {
        main: "#FFEAB5",
      },
    },
  });
export default theme;